/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Avatar, Menu, Popover } from "antd";
import { Typography, Loading } from "../../../../core";
import { logout } from "../../../../redux/Action/auth";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { theme } from "../../../../styles";
import styled from "styled-components";

import { getProfile, clearState } from "../../../../redux/Action/auth";
const Notify_Utils = require("../../../../helper/utils/Notification");

const { colors } = theme;
const TypoProps = {
  as: "span",
  fontSize: "14px",
  weight: "600",
  letterSpacing: "0.2px",
  color: colors.grayscale_black,
};
const Container = styled.div`
  span {
    margin: 0px 10px;
  }
  cursor: pointer;
`;
const StyledMenu = styled(Menu)`
  width: 150px;
  > li {
    padding: 0px !important;
  }
`;
const Account = ({ theme }) => {
  const [state, setState] = useState({
    visible: false,
  });
  const dispatchtoAction = useDispatch();
  const account = useSelector((state) => state.auth);

  let userReduxState = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  React.useEffect(() => {
    if (userReduxState.getUserDetailSuccess) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "success",
        userReduxState.getUserDetailSuccess
      );
      dispatchtoAction(clearState());
    }
    if (userReduxState.getUserDetailFail) {
      setIsLoading(false);
      dispatchtoAction(clearState());
    }
  }, [userReduxState]);

  useEffect(() => {
    let AuthoriationToken = localStorage.getItem("usertoken");
    setIsLoading(true);
    dispatchtoAction(getProfile({ token: AuthoriationToken }));
  }, []);

  const handleVisibleChange = (visible) => {
    setState({ visible });
  };

  return (
    <Popover
      content={<MenuCompo />}
      title={false}
      placement="bottomRight"
      trigger="click"
      visible={state.visible}
      onVisibleChange={handleVisibleChange}
    >
      <div>{isLoading ? <Loading /> : ""}</div>

      <Container>
        <Typography
          {...TypoProps}
          text={account.users ? account.users.name : ""}
        />
        <Avatar
          size={50}
          src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
        />
      </Container>
    </Popover>
  );
};
const MenuCompo = () => {
  const dispatch = useDispatch();
  let history = useHistory();
  const clickHandler = () => {
    dispatch(logout());
    history.push("/");
  };
  return (
    <StyledMenu>
      <Menu.Item
        key="profile"
        icon={<UserOutlined />}
        onClick={() => history.push("/profile")}
      >
        <Typography {...TypoProps} text="Profile" />
      </Menu.Item>
      <Menu.Item
        key="companies"
        onClick={() => history.push("/")}
        icon={<LogoutOutlined />}
      >
        <Typography {...TypoProps} text="My Companies" />
      </Menu.Item>
      <Menu.Item key="logout" onClick={clickHandler} icon={<LogoutOutlined />}>
        <Typography {...TypoProps} text="Logout" />
      </Menu.Item>
    </StyledMenu>
  );
};
export default Account;
